module.exports = __webpack_public_path__ + "footer.jpg?0e7d0a10a66f6e4146e0f36db0e7e466";